import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { useTranslation, Trans } from 'next-i18next';
import { isProductAvailableForSale, getProductLinkFromUrlRewrites } from './utils/product.js';
import { logImgLoadErrorToRelic } from './utils/logToRelic.js';
import Link from './components/Link/index.js';
import { CoreContext } from './context/index.js';

const UpsellProducts = ({ items }) => {
    const { t } = useTranslation('', { keyPrefix: '' });
    const { t: tHeading } = useTranslation('', { keyPrefix: '$common.$headings' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { data: { siteConfig: { product: { ymalQty = 4 } = {} }, }, } = useContext(CoreContext);
    const { asPath, locale } = useRouter();
    if (!items.length)
        return null;
    return (React.createElement("section", null,
        React.createElement("div", { className: "similar-items clearfix" },
            React.createElement("h2", null, tHeading('youMayAlsoLike')),
            React.createElement("ul", null, items
                // Show only available for sale UpsellProducts
                .filter(item => isProductAvailableForSale(item.backorder_status, item.stock_status))
                .slice(0, ymalQty)
                .map(item => {
                const imgUrl = item.thumbnail.url;
                return (React.createElement("li", { key: item.id },
                    React.createElement("div", null,
                        React.createElement(Link, { href: getProductLinkFromUrlRewrites(item.url_rewrites, locale), ariaLabel: tLabel('shop', { productName: item.name }), className: "upsell-items-link custom-focus", noUnderline: true },
                            React.createElement("img", { src: imgUrl, className: "upsell-items-img", alt: t('$common.productName', { productName: item.name }), loading: "lazy", onError: () => logImgLoadErrorToRelic(asPath, imgUrl) }),
                            React.createElement("h3", { className: "tlt-related" },
                                React.createElement("span", null,
                                    React.createElement(Trans, { i18nKey: "ymalCtaLabel", t: tLabel, values: { productName: item.name }, components: { span: React.createElement("span", null) } })))))));
            })))));
};

export { UpsellProducts as U };
//# sourceMappingURL=UpsellProducts-Wc3lCklO.js.map
